module.exports = __webpack_public_path__ + "img/submit_students_img1.c00b592a.png";